




































import { Component, Vue, Prop } from 'vue-property-decorator';
import OrderbookBoard from './OrderbookBoard.vue';
import { OrderbookArrayWithRak } from '@/types/orderbook';
import 'animate.css';

@Component({
  name: 'OrderbookContent',
  components: {
    OrderbookBoard,
  },
})
export default class OrderbookContent extends Vue {
  public lineMaxWidth = 144;

  @Prop(Boolean) public loaded!: boolean;
  @Prop(Object) public orderbook!: OrderbookArrayWithRak;
  @Prop(Number) public ltp!: number;
  @Prop(Number) public lastTickDirection!: number;
  @Prop(Number) public spread!: number;

  get directionIcon() {
    if (this.lastTickDirection > 0) {
      return 'arrow_upward';
    } else if (this.lastTickDirection < 0) {
      return 'arrow_downward';
    }
  }
  get lineMax() {
    return (
      Math.max(
        ...this.orderbook.bids.map((bid) => bid.size),
        ...this.orderbook.asks.map((ask) => ask.size),
      ) * 1.1
    );
  }
  get ltpClass() {
    return {
      ltpUp: this.lastTickDirection > 0,
      ltpDown: this.lastTickDirection < 0,
    };
  }
}
